import React from 'react';
import * as S from './SubmitedDetails.styles';


const SubmitedDetails = (props) => {
  const {operatorName,busType,bpViewTime,bpViewAddress,dpViewTime,dpViewAddress,travellersName,primaryContactName,primaryContactNumber,primaryEmailId,go_safe,sf_en} = props;
  
  return(
    <S.SubmitedDetails>
        <S.BusDetails>
            <S.BusName>{operatorName}</S.BusName>
            <S.BusType>{busType}</S.BusType>
            {(go_safe || sf_en) ?
               
            <S.GoSafeTag>
                  <img src='https://gos3.ibcdn.com/goSafelogo-1591083260.png' width='60px' /> 
                <span>High Safety and Hygiene</span>
            </S.GoSafeTag> :null}
        </S.BusDetails>
        <S.LocationDetails>
            <S.LocationWrap>
                <S.Time>{bpViewTime}</S.Time>
                <S.LocationName>{bpViewAddress}</S.LocationName>
            </S.LocationWrap>
            <S.LocationWrap>
                <S.Time>{dpViewTime}</S.Time>
                <S.LocationName>{dpViewAddress}</S.LocationName>
            </S.LocationWrap>
        </S.LocationDetails>
        {travellersName && travellersName.length ? <S.PassengerDetails>
            <S.TravellerTitle>Travellers: </S.TravellerTitle>
            <S.TravellerList>
                <ul>
                    {travellersName.map((name,index)=>{
                        return (  <li key={name+index}><S.Bullet>{'\u2B24'}</S.Bullet>{name}</li>
                        )
                    })}
                    
                </ul>
            </S.TravellerList> 
        </S.PassengerDetails>:null}
        <S.PassengerDetails>
            <S.TravellerTitle>Primary Contact: </S.TravellerTitle>
            <S.ContactPerson>
                <S.ContactName>{primaryContactName}</S.ContactName>
                <span style={{display:"flex"}}>
                <S.PhoneNum>{primaryContactNumber}</S.PhoneNum>
                <S.EmailId>{primaryEmailId}</S.EmailId>
                </span>
            </S.ContactPerson>
        </S.PassengerDetails>
        
    </S.SubmitedDetails>
);
    }
export default SubmitedDetails;
/**
 *    <S.SubmitedDetails>
        <S.BusDetails>
            <S.BusName>{operatorName}</S.BusName>
            <S.BusType>{busType}</S.BusType>
            <S.GoSafeTag>
                <img src='' />
                <span>High Safety and Hygiene</span>
            </S.GoSafeTag>
        </S.BusDetails>
        <S.LocationDetails>
            <S.LocationWrap>
                <S.Time>{bpViewTime}</S.Time>
                <S.LocationName>{bpViewAddress}</S.LocationName>
            </S.LocationWrap>
            <S.LocationWrap>
                <S.Time>{dpViewTime}</S.Time>
                <S.LocationName>{dpViewAddress}</S.LocationName>
            </S.LocationWrap>
        </S.LocationDetails>
        <S.PassengerDetails>
            <S.TravellerTitle>Travellers: </S.TravellerTitle>
            <S.TravellerList>
                <ul>
                    {travellersName.map((name,index)=>{
                        return (  <li key={name+index}><S.Bullet>{'\u2B24'}</S.Bullet>{name}</li>
                        )
                    })}
                    
                </ul>
            </S.TravellerList>
        </S.PassengerDetails>
        <S.PassengerDetails>
            <S.TravellerTitle>Primary Contact: </S.TravellerTitle>
            <S.ContactPerson>
                <S.ContactName>{primaryContactName}</S.ContactName>
                <S.PhoneNum>{primaryContactNumber} {primaryEmailId}</S.PhoneNum>
            </S.ContactPerson>
        </S.PassengerDetails>
        
    </S.SubmitedDetails>
);
    }
export default SubmitedDetails;
/**
 *    <S.SubmitedDetails>
        <S.BusDetails>
            <S.BusName>{operatorName}</S.BusName>
            <S.BusType>{busType}</S.BusType>
            <S.GoSafeTag>
                <img src='https://gos3.ibcdn.com/goSafelogo-1591083260.png' width='60px' />
                <span>High Safety and Hygiene</span>
            </S.GoSafeTag>
        </S.BusDetails>
        <S.LocationDetails>
            <S.LocationWrap>
                <S.Time>3:30 PM, 21st Feb 2019</S.Time>
                <S.LocationName>CS-Accenture B7 Eco Space</S.LocationName>
                <S.LocationAddress>
                RMZ Ecospace Internal Rd, Adarsh Palm Retreat, Bellandur, Bengaluru, Karnataka 560103
                </S.LocationAddress>
            </S.LocationWrap>
            <S.LocationWrap>
                <S.Time>3:30 PM, 21st Feb 2019</S.Time>
                <S.LocationName>CS-Accenture B7 Eco Space</S.LocationName>
                <S.LocationAddress>
                RMZ Ecospace Internal Rd, Adarsh Palm Retreat, Bellandur, Bengaluru, Karnataka 560103
                </S.LocationAddress>
            </S.LocationWrap>
        </S.LocationDetails>
        <S.PassengerDetails>
            <S.TravellerTitle>Travellers: </S.TravellerTitle>
            <S.TravellerList>
                <ul>
                    <li><S.Bullet>{'\u2B24'}</S.Bullet> Radhakrishnan</li>
                    <li><S.Bullet>{'\u2B24'}</S.Bullet> Radhakrishnan</li>
                    <li><S.Bullet>{'\u2B24'}</S.Bullet> Radhakrishnan</li>
                    <li><S.Bullet>{'\u2B24'}</S.Bullet> Radhakrishnan</li>
                    <li><S.Bullet>{'\u2B24'}</S.Bullet> Radhakrishnan</li>
                    <li><S.Bullet>{'\u2B24'}</S.Bullet> Radhakrishnan</li>

                </ul>
            </S.TravellerList>
        </S.PassengerDetails>
        <S.PassengerDetails>
            <S.TravellerTitle>Primary Contact: </S.TravellerTitle>
            <S.ContactPerson>
                <S.ContactName>Radhakrishnan</S.ContactName>
                <S.PhoneNum>+91-9899999999 ghesfgf@gmail.com</S.PhoneNum>
            </S.ContactPerson>
        </S.PassengerDetails>
        <S.SelectedAmenities>
            <S.AmenitiesTxt>Reasons you’ve made a good choice</S.AmenitiesTxt>
            <S.AmenitiesWrap>
                <S.AmenitiesTabs><span>On- time guarantee</span></S.AmenitiesTabs>
                <S.AmenitiesTabs><span>Live Tracking</span></S.AmenitiesTabs>
            </S.AmenitiesWrap>
        </S.SelectedAmenities>
        
    </S.SubmitedDetails>

 */